/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import find from 'lodash/find';
// import Select from 'react-select';
// import * as find from 'lodash/find';
// import * as sortBy from 'lodash/sortBy';
import '../css/About.css';
import '../css/AddVehicle.css';
import { Row } from 'react-bootstrap';
// import MyUtil from '../../functions/MyUtil';
import UserGroupApi from '../../functions/api/user/UserGroupApi';
import ModuleApi from '../../functions/api/user/ModuleApi';
import NotifyAlert from '../../components/Notify/NotifyAlert';
import ConvertUserGroup from '../../functions/ConvertUserGroup';
import NotifyError from '../../components/Notify/NotifyError';
import ListModulePermission from './ListModulePermission';
// import moment from 'moment'
// import debounce from "lodash.debounce";

class FormAddUserGroup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user_group_id: '',
      user_group_name: '',
      description: '',
      permission: [],
      isEdit: false,
      defaultPermissions: {},
    };
  }

  componentDidMount = async () => {
    const { match } = this.props;
    const modules = await ModuleApi.getAllModules();
    const defaultPermissions = modules.map((m) => ({ ...m, permission: [] }));
    this.setState({ defaultPermissions });

    if (match.params && match.path === '/group/edit/:user_group_id') {
      const { user_group_id: userGroupId } = match.params;
      const userGroup = await UserGroupApi.getOne(userGroupId);
      const { user_group_id, user_group_name, description, permission } =
        userGroup;
      const arrPermissions = permission ? JSON.parse(permission) : [];
      const userGroupPermissions = defaultPermissions.map((p) => {
        const currentPermission = find(arrPermissions, {
          module_id: p.module_id,
        });

        if (undefined !== currentPermission) {
          return { ...p, permission: currentPermission.permission };
        }

        return p;
      });
      // console.log(userGroupPermissions);

      this.setState({
        isEdit: true,
        user_group_id,
        user_group_name,
        description,
        permission: userGroupPermissions,
      });
    } else {
      this.setState({ permission: defaultPermissions });
    }
  };

  handleChange = async (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  clearForm = () => {
    const { defaultPermissions } = this.state;
    this.setState({
      user_group_id: '',
      user_group_name: '',
      description: '',
      permission: defaultPermissions,
    });
  };

  handleCreate = async () => {
    const { check } = ConvertUserGroup.handleCheck(this.state);
    const { isEdit } = this.state;
    if (!check) {
      let result = '';
      if (isEdit) {
        const module = ConvertUserGroup.handleUpdate(this.state);
        result = await UserGroupApi.update(module);
      } else {
        const module = ConvertUserGroup.handleNew(this.state);
        result = await UserGroupApi.create(module);
      }

      console.log('result ', result);
      if (result && !result.message) {
        let message = '';
        if (isEdit) message = 'Sửa user group thành công!';
        else message = 'Thêm user group thành công';

        NotifyAlert('Thành công', message);
        if (!isEdit) this.clearForm();
      } else {
        NotifyError('Lỗi', result.message);
      }
    } else {
      NotifyAlert('Thông báo', `Dữ liệu bạn nhập bị thiếu. Hãy kiểm tra lại.`);
    }
  };

  handleChangePermission = (changedPermission) => {
    const { permission } = this.state;
    const newPermission = permission.map((obj) =>
      obj.module_id === changedPermission.module_id
        ? { ...obj, permission: changedPermission.permission }
        : obj
    );
    this.setState({ permission: newPermission });
  };

  render() {
    const { user_group_name, description, permission, isEdit } = this.state;
    return (
      <div>
        <div
          style={{
            display: 'inline-flex',
            width: '90%',
            margin: '10px 10px 20px 21px',
          }}
        >
          <Link to="/group">
            <div className="button-back button">
              <div style={{ fontSize: '16px' }}>Quay lại</div>
            </div>
          </Link>
          <div
            style={{
              color: '#107d82',
              fontWeight: '600',
              fontSize: '20px',
              marginLeft: '30%',
            }}
          >
            {isEdit ? 'Sửa user group' : 'Thêm user group'}
          </div>
        </div>

        <div
          style={{ backgroundColor: '#ececec', margin: '5px 20px 20px 20px' }}
        >
          <Row className="row-form">
            <div className="row-child row-child-small">
              <div className="title-content-page">User Group Name</div>
              <input
                className="input-normal full-width"
                onChange={this.handleChange}
                name="user_group_name"
                value={user_group_name}
                placeholder="Nhập vào user group name"
              />
            </div>

            <div className="row-child row-child-small">
              <div className="title-content-page">Mô tả</div>
              <input
                className="input-normal full-width"
                onChange={this.handleChange}
                name="description"
                value={description}
                placeholder="Nhập vào mô tả"
              />
            </div>
          </Row>

          <Row className="row-form">
            <div className="row-child row-child-small">
              <div className="title-content-page">Phân Quyền</div>
            </div>
            <ListModulePermission
              permission={permission}
              handleChangePermission={(changedPermission) =>
                this.handleChangePermission(changedPermission)
              }
            />
          </Row>
        </div>

        <Row
          style={{
            display: 'inline-flex',
            width: '100%',
            marginBottom: '30px',
          }}
        >
          <button
            type="button"
            className="btn-edit button btn-save"
            style={{ background: '#107d82' }}
            onClick={this.handleCreate}
          >
            Lưu thay đổi
          </button>
        </Row>
      </div>
    );
  }
}

export default FormAddUserGroup;
